import './style.css';
import * as Sentry from '@sentry/vue';
import { createHead } from '@unhead/vue/client';
import hasOwn from 'object.hasown';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createGtag } from 'vue-gtag';
import App from './App.vue';
import { ENVIRONMENT } from './config';
import router from './router';

if (!Object.hasOwn) {
  hasOwn.shim();
}

const app = createApp(App);
const head = createHead();

Sentry.init({
  app,
  dsn: 'https://24193bfa46240d12b193a49139861964@o4505475530358784.ingest.us.sentry.io/4510277395349504',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  tracesSampleRate: 0.05,
  enabled: ENVIRONMENT === 'production',
  tracePropagationTargets: ['localhost'],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.5,
  ignoreErrors: [
    `undefined is not an object (evaluating 'window.webkit.messageHandlers')`, // An issue with Sentry in iOS Facebook browser - https://github.com/getsentry/sentry-javascript/issues/3040
    `undefined is not an object (evaluating 'window.webkit.messageHandlers[e].postMessage')`,
  ],
});

// Google Analytics - Only in Production
if (ENVIRONMENT === 'production') {
  const gtag = createGtag({
    tagId: 'G-4SBR10LQN3',
  });
  app.use(gtag);
}

app.use(head);
app.use(createPinia());
app.use(router);

app.mount('#app');
